import type { AgeSummaryShellProps } from '@/modules/employer/pages/components/AgeSummaryShell/AgeSummaryShell.types'

import { AgeSummary } from '@/components/@Shared/UserManagmentCharts/AgeSummary/AgeSummary'

import { useEmployerStatsServiceEmployerStatsControllerGetAgeStats } from '@/__generated__/queries'

export function AgeSummaryShell({ onUpdateChartsData }: AgeSummaryShellProps) {
  const { data, isFetching, isLoading } =
    useEmployerStatsServiceEmployerStatsControllerGetAgeStats()

  return (
    <AgeSummary
      data={data}
      isLoading={isLoading || isFetching}
      onUpdateChartsData={onUpdateChartsData}
    />
  )
}
